module.exports = __webpack_public_path__ + "img/pc5.886a2b2f.png";